<template>
  <div>
    <table style="width: 100%">
      <tr>
    <my-header></my-header>
      </tr>
      <tr>
        <td colspan="3">
          <table style="width: 100%; border-collapse: collapse; margin-top:10px" border="1" v-for="head in ProgCourseWiseStudentCount">
            <thead>
              <tr>
                <th style="background-color:gray" class="text-center" colspan="6">
                  <h4>{{head.ProgramName}} - {{head.SessionName}}</h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style="background-color:	#C0C0C0" width="5%">Sr. No.</th>
                <th style="background-color:	#C0C0C0" width="25%">Subject</th>
                <th style="background-color:	#C0C0C0" width="25%">Instructor Name</th>
                <th style="background-color:	#C0C0C0" width="10%">Course Code</th>
                <th style="background-color:	#C0C0C0" width="5%">Credit Hrs</th>
                <th style="background-color:	#C0C0C0" width="10%">No Of Students</th>
              </tr>
              <tr v-for="(item, ind) in head.Child">
                <td align="center">{{ind+1}}</td>
                <td>{{item.CourseName}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.CourseCode}}</td>
                <td align="right">{{item.CreditHours}}</td>
                <td align="right">{{item.NoOfStudents}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        test: "",
        ProgCourseWiseStudentCount: [],
      }
    },

      created: function () {
      this.pageload();
    },
    methods:
    {
      pageload() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const ActiveSemesterID = params.get('semID');
        const ProgramID = params.get('progID');
        axios.post('/api/DCApi/SearchStudentCount?progID=' + ProgramID + '&semID=' + ActiveSemesterID)
          .then(function (response) {
            vm.ProgCourseWiseStudentCount = response.data.lst;
          })
      },
    }
  })
</script>

<style>
  td {
    padding-left: 3px;
  }

  th {
    padding-left: 3px;
    color: black;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/progCourseWiseStudentCountPrint.vue